export default __webpack_public_path__ + "static/media/Front-9-Round-Gym.06488dba.jpg";